import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 0.5rem;
`

export const Label = styled.label`
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5rem;
  color: ${({theme}) => theme.colors.gray500 };
`

export const Input = styled.textarea`
  color: ${({ theme }) => theme.colors.gray500};
  font-size: 1rem;
  font-weight: 700;
  padding: 1rem;
  border: 0px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray500};
  border-radius: 0.5rem 0.5rem 0 0;
  background: ${({ theme }) => theme.colors.gray100};
  width: 100%;
  resize: vertical;

  &:valid:not(:placeholder-shown):valid:not(:focus) {
    background: ${({ theme }) => theme.colors.white};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.gray500};
    opacity: 1;
  }

`